(() => {
  if (window.location.hostname !== '127.0.0.1') return;

  const target = new URLSearchParams(window.location.search).get('acttua_preview');
  if (!target) return;

  const [type, handle] = target.split(':');
  if (!type || !handle) return;

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;',
  })[char]);
  const imageUrl = (name) => window.ActtuaLocalPreviewImages?.[name] || '';
  const imageMarkup = (names, title) => names
    .map((name) => imageUrl(name) ? `<img src="${imageUrl(name)}" alt="${escapeHtml(title)}" loading="eager">` : '')
    .join('');

  const dataUrl = new URL('acttua-local-content-preview.json', document.currentScript?.src || window.location.href);

  fetch(dataUrl, { cache: 'no-store' })
    .then((response) => response.ok ? response.json() : Promise.reject(new Error('No se pudo leer el plan local.')))
    .then((data) => {
      const entries = type === 'article' ? data.articles : type === 'product' ? data.products : [];
      const entry = entries.find((item) => item.handle === handle);
      if (!entry) throw new Error('No existe un contenido pendiente con esa URL.');

      const main = document.querySelector('#MainContent');
      if (!main) return;
      document.title = `Vista previa: ${entry.title}`;
      main.innerHTML = type === 'article'
        ? `<article class="acttua-content-preview acttua-content-preview--article"><p class="acttua-content-preview__badge">Vista previa local · No publicado</p><header><h1>${escapeHtml(entry.title)}</h1><p class="acttua-content-preview__meta">${escapeHtml(entry.author || 'Acttua')} · ${entry.tags.map(escapeHtml).join(' · ')}</p></header><div class="acttua-content-preview__images">${imageMarkup(entry.previewImages, entry.title)}</div><div class="rte acttua-content-preview__body">${entry.bodyHtml}</div></article>`
        : `<article class="acttua-content-preview acttua-content-preview--product"><p class="acttua-content-preview__badge">Vista previa local · Producto pendiente</p><div class="acttua-content-preview__product-grid"><div class="acttua-content-preview__images">${imageMarkup(entry.previewImages, entry.title)}</div><div><h1>${escapeHtml(entry.title)}</h1>${entry.price ? `<p class="acttua-content-preview__price">${escapeHtml(entry.price)}</p>` : ''}<div class="rte acttua-content-preview__body">${entry.descriptionHtml || ''}</div><button class="btn btn--primary" type="button" disabled>Producto pendiente de crear</button></div></div></article>`;
      document.body.classList.add('acttua-content-preview-active');
    })
    .catch((error) => console.error('[Acttua preview]', error.message));
})();
